import axios from "../axios";

// GET endpoints
export async function fetchReportVariables(reportId) {
  return axios
    .get(`/service/reports/${reportId}/variables`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response?.data || error;
    });
}

export async function fetchReportVariableGroups(reportId) {
  return axios
    .get(`/service/reports/${reportId}/variable_groups`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response?.data || error;
    });
}

export async function fetchReportVariableTypeGroups(reportId) {
  return axios
    .get(`/service/reports/${reportId}/variable_type_groups`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response?.data || error;
    });
}

// Variable Groups
export async function createReportVariableGroup(reportId, payload) {
  return axios
    .post(`/service/reports/${reportId}/variable_groups`, {
      variable_group: payload,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response?.data || error;
    });
}

export async function updateReportVariableGroup(reportId, groupId, payload) {
  return axios
    .put(`/service/reports/${reportId}/variable_groups/${groupId}`, {
      variable_group: payload,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response?.data || error;
    });
}

export async function deleteReportVariableGroup(reportId, groupId) {
  return axios
    .delete(`/service/reports/${reportId}/variable_groups/${groupId}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response?.data || error;
    });
}

// Variables
export async function createReportVariable(reportId, payload) {
  return axios
    .post(`/service/reports/${reportId}/variables`, {
      variable: payload,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response?.data || error;
    });
}

export async function updateReportVariable(reportId, variableId, payload) {
  return axios
    .put(`/service/reports/${reportId}/variables/${variableId}`, {
      variable: payload,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response?.data || error;
    });
}

export async function deleteReportVariable(reportId, variableId) {
  return axios
    .delete(`/service/reports/${reportId}/variables/${variableId}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response?.data || error;
    });
}

// Measurements
export async function createReportVariableMeasurement(
  reportId,
  variableId,
  payload
) {
  return axios
    .post(`/service/reports/${reportId}/variables/${variableId}/measurements`, {
      measurement: payload,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response?.data || error;
    });
}

export async function fetchReportVariableMeasurements(reportId, variableId) {
  return axios
    .get(`/service/reports/${reportId}/variables/${variableId}/measurements`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response?.data || error;
    });
}

export async function deleteReportVariableMeasurement(
  reportId,
  variableId,
  measurementId
) {
  return axios
    .delete(
      `/service/reports/${reportId}/variables/${variableId}/measurements/${measurementId}`
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response?.data || error;
    });
}

// Variable Type Groups
export async function createReportVariableTypeGroup(reportId, payload) {
  return axios
    .post(`/service/reports/${reportId}/variable_type_groups`, {
      variable_type_group: payload,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response?.data || error;
    });
}

export async function updateReportVariableTypeGroup(reportId, typeGroupId, payload) {
  return axios
    .put(`/service/reports/${reportId}/variable_type_groups/${typeGroupId}`, {
      variable_type_group: payload,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response?.data || error;
    });
}

export async function deleteReportVariableTypeGroup(reportId, typeGroupId) {
  return axios
    .delete(`/service/reports/${reportId}/variable_type_groups/${typeGroupId}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response?.data || error;
    });
}


